import { Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Container, Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import ModalFormParameterCountry from "./Components/ModalFormParameterCountry";

function MasterCountry() {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionCurrency, setOptionCurrency] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalPreload, setModalPreload] = useState(null);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getOptionCurrency = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/currency/datatable?page=1&per_page=10&search=`,
        { headers }
      );
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.currency_name,
      }));
      setOptionCurrency(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/country/table`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const handleDelete = async id => {
    try {
      setLoadingPage(true);
      await axios.delete(`${hardBaseUrl}/country/delete/${id}`, {
        headers,
      });
      ModalSuccess("Succesfully delete country").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  useEffect(() => {
    getOptionCurrency();
  }, []);
  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Country">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Country"
              onClick={() => {
                setModalVisible(true);
                setModalPreload(null);
              }}
              startIcon={<Add />}
              size="large"
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.per_page}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "per_page")
          }
          isHaveAction
          tooltipEdit="Update Country"
          handleEdit={item => {
            setModalVisible(true);
            setModalPreload(item);
          }}
          deleteConfirmation
          tooltipDelete="Delete Country"
          deleteConfirmationKey="country_name"
          handleDelete={item => handleDelete(item?.id)}
        />
      </Container>
      {modalVisible && (
        <ModalFormParameterCountry
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          preload={modalPreload}
          optionCurrency={optionCurrency}
          getDataTable={getDataTable}
        />
      )}
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Parameter",
    link: "/admin/parameter/admin-country",
  },
  {
    label: "Country",
    active: true,
  },
];
const columnTable = [
  {
    name: "country_iso_code",
    title: "Country Code",
  },
  {
    name: "country_name",
    title: "Country Name",
  },
  {
    name: "currency",
    title: "Currency",
    renderText: item => item?.currency_iso_code,
  },
];
export default MasterCountry;
